export default __webpack_public_path__ + "static/media/bm-swamp3.3bad3e08.png";